import { IdentityFragment, getTypeOrNull } from '@spotify/confidence-graphql';

export const getIdentityDescription = (
  identity: IdentityFragment,
  fallback: string | undefined = undefined,
): string | undefined => {
  return (
    getTypeOrNull(identity?.group)?.description ??
    getTypeOrNull(identity?.apiClient)?.description ??
    (identity?.everyone ? 'All users in this workspace' : undefined) ??
    fallback
  );
};

export type IdentityKind =
  | 'user'
  | 'group'
  | 'apiClient'
  | 'everyone'
  | 'service'
  | 'agent';

export const identityKind = (name: string): IdentityKind => {
  if (name.startsWith('identities/u')) {
    return 'user';
  }

  if (name.startsWith('identities/g')) {
    return 'group';
  }

  if (name.startsWith('identities/c')) {
    return 'apiClient';
  }

  if (name.startsWith('identities/everyone')) {
    return 'everyone';
  }

  if (name.startsWith('identities/s')) {
    return 'service';
  }

  if (name.startsWith('identities/a')) {
    return 'agent';
  }

  throw new Error(`Invalid identity name: ${name}`);
};
